import lessRequire from '../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';

import { Field, FieldArray, reduxForm } from 'redux-form';
import _debounce from 'lodash/debounce';

import inputField from '../../shared/form-elements/input';
import checkboxField from '../../shared/form-elements/checkbox';

lessRequire('modules/global-postback/components/form.less');

const Fields = ({
	fields,
	intl,
	removeField,
	checkboxDisabledStatus,
	onChecked,
	addField,
	errors,
	changeUrl,
	postbackTypeErrors,
	fieldsLimit
}) => {
	return (
		<div className="fields-wrapper">
			{fields.map((postback, idx) =>
				<div  className="field-wrapper" key={idx}>
					<div className="global-postback__url">
						<div className='url__number'>{idx + 1}.</div>
						<Field name={`${postback}.global_postback_url`}
							component={inputField}
							onChange={_debounce(e => changeUrl(e.currentTarget.value, idx), 150)}
							placeholder={intl('Постбэк URL')}
							errors={errors} />
						{fields.length > 1
							? <a
								className="url__delete"
								onClick={e => removeField(e, idx)}
							></a>
							: <div></div>}
					</div>
					<div className="global-postback__checkbox-wrap">
						<Field name={`${postback}.postback_send_status`}
							labelText={intl('Постбэк при смене статуса')}
							component={checkboxField}
							shouldDisable={checkboxDisabledStatus[idx]
							&& checkboxDisabledStatus[idx].postback_send_status}
							onChange={e => onChecked('postback_send_status', e.currentTarget.value, idx)}/>

						<Field name={`${postback}.postback_ignore_trash`}
							labelText={intl('Не слать постбэк по лидам со статусом trash')}
							component={checkboxField}
							shouldDisable={checkboxDisabledStatus[idx]
							&& checkboxDisabledStatus[idx].postback_ignore_trash}
							onChange={e => onChecked('postback_ignore_trash', e.currentTarget.value, idx)}/>

						<Field name={`${postback}.postback_only_approved`}
							labelText={intl('Лиды в статусе "approved"')}
							component={checkboxField}
							shouldDisable={checkboxDisabledStatus[idx]
							&& checkboxDisabledStatus[idx].postback_only_approved}
							onChange={e => onChecked('postback_only_approved', e.currentTarget.value, idx)}/>

						<Field name={`${postback}.postback_only_pending`}
							labelText={intl('Лиды в статусе "pending"')}
							component={checkboxField}
							shouldDisable={checkboxDisabledStatus[idx]
							&& checkboxDisabledStatus[idx].postback_only_pending}
							onChange={e => onChecked('postback_only_pending', e.currentTarget.value, idx)}/>
						<Field name={`${postback}.postback_send_payout_for_approved_only`}
							labelText={intl('Слать выплату только по апрувнутым лидам')}
							component={checkboxField}
							shouldDisable={checkboxDisabledStatus[idx]
								&& checkboxDisabledStatus[idx].postback_send_payout_for_approved_only}
							onChange={e => onChecked('postback_send_payout_for_approved_only', e.currentTarget.value, idx)}
						/>
						<Field name={`${postback}.postback_ignore_restricted`}
							onChange={e => onChecked('postback_ignore_restricted', e.currentTarget.value, idx)}
							labelText={intl('Не слать постбек по restricted регионам')}
							component={checkboxField}
						/>
						<Field name={`${postback}.postback_only_rejected`}
							onChange={e => onChecked('postback_only_rejected', e.currentTarget.value, idx)}
							shouldDisable={checkboxDisabledStatus[idx]
								&& checkboxDisabledStatus[idx].postback_only_rejected}
							labelText={intl('Лиды в статусе "rejected"')}
							component={checkboxField}
						/>
						<Field name={`${postback}.postback_on_payout_change`}
							onChange={e => onChecked('postback_on_payout_change', e.currentTarget.value, idx)}
							labelText={intl('Постбек при смене payout')}
							component={checkboxField}
						/>
						<Field name={`${postback}.postback_only_trash`}
							onChange={e => onChecked('postback_only_trash', e.currentTarget.value, idx)}
							shouldDisable={checkboxDisabledStatus[idx]
								&& checkboxDisabledStatus[idx].postback_only_trash}
							labelText={intl('Лиды в статусе "trash"')}
							component={checkboxField}
						/>
						<div className="type-errors">{postbackTypeErrors[idx]}</div>
					</div>
				</div>
			)}
			{fields.length < fieldsLimit
				? <button
					className="button yellow-btn add-postback"
					onClick={addField}
				></button>
				: <div></div>}
		</div>
	);
};

const Form = props => {
	const {handleSubmit, saveForm, intl, affiliateID} = props;
	const onSubmit = handleSubmit(d => saveForm(d));

	return (
		<form className="global-postback__form" onSubmit={onSubmit}>
			<FieldArray
				name='postbacks'
				{...props}
				component={Fields}
			/>

			<div className="global-postback__info clearfix">
				<div className="global-postback__info-block">
					<p>
						{intl('Глобальный постбэк будет срабатывать для всех ваших потоков.')}
					</p>

					<p>
						{intl('При настроенном постбэке в каком-то из потоков, он имеет приоритет над глобальным.')}
						{intl('В такой ситуации срабатывать будет постбэк, указанные в потоке.')}
					</p>
				</div>

				<div className="global-postback__info-block">
					<p>
						{intl('Постбэк запрос будет отправлен на указанный адрес методом GET.')}
						{intl('Для передачи параметров в запрос Вы можете использовать макросы, указанные ниже.')}
					</p>

					<p>
						{intl('Пример, постбэк ссылки для передачи суммы заработка и субаккаунта:')}
						<span>http://example.com/mystat.php?myprofit={'{payout}'}&mySubID={'{sid1}'}</span>.
						{intl('В момент перехода макросы')} <span>{'{payout}'}]</span> {intl('и')} <span>{'{sid1}'}</span>
						{intl('будут заменены на соответствующие значения.')}
					</p>
				</div>
			</div>

			<table className="dashboard-table postback__table">
				<thead className="dashboard-table__head font-proxima-nova-semibold">
					<tr>
						<th>{intl('Макрос')}</th>
						<th>{intl('Значение')}</th>
					</tr>
				</thead>
				<tbody className="dashboard-table__body">
					<tr>
						<td className="macros_title"><span>id</span></td>
						<td className="macros_value"><span>{intl('id конверсии')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>date</span></td>
						<td className="macros_value"><span>{intl('время конверсии UTC+0')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>campaign_id</span></td>
						<td className="macros_value"><span>{intl('идентификатор потока')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>campaign_language</span></td>
						<td className="macros_value"><span>{intl('язык кампании')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>offer_id</span></td>
						<td className="macros_value"><span>{intl('идентификатор оффера')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>country_code</span></td>
						<td className="macros_value"><span>{intl('код страны')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>ip</span></td>
						<td className="macros_value"><span>{intl('IP адрес')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>traffic_type</span></td>
						<td className="macros_value"><span>{intl('Тип траффика')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>sid1, sid2, sid3, sid4, sid5</span></td>
						<td className="macros_value"><span>sid1, sid2, sid3, sid4, sid5</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>status</span></td>
						<td className="macros_value">
							<span>
								{intl('статус конверсии')}
								{' '}
								{intl(
									'("pending" - ожидает обработки, "approved" - подтверждено,' +
										' "rejected" - отклонено, "trash" - невалидный)'
								)}
							</span>
						</td>
					</tr>
					<tr>
						<td className="macros_title"><span>payout</span></td>
						<td className="macros_value"><span>{intl('размер выплаты')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>currency</span></td>
						<td className="macros_value"><span>{intl('валюта выплаты')}</span></td>
					</tr>
					{
						window.globalConfig.redeemNotificationAffiliates.includes(affiliateID) && (
							<tr>
								<td className="macros_title"><span>is_redeemed</span></td>
								<td className="macros_value"><span>{intl('выкуп') + ': true, false'}</span></td>
							</tr>
						)
					}
					<tr>
						<td className="macros_title"><span>type</span></td>
						<td className="macros_value"><span>{intl('тип конверсии')} ("cpa", "cancellations")</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>campaign_country_code</span></td>
						<td className="macros_value"><span>{intl('ГЕО потока')}</span></td>
					</tr>
					<tr>
						<td className="macros_title"><span>reason</span></td>
						<td className="macros_value"><span>{intl('Причина отмены')}</span></td>
					</tr>
				</tbody>
			</table>

			<div className="global-postback__submit">
				<button className="button yellow-btn font-proxima-nova-semibold" type="submit">{intl('Сохранить')}</button>
			</div>
		</form>
	);
};

Form.propTypes = {
	handleSubmit: PropTypes.func,
	saveForm: PropTypes.func,
	errors: PropTypes.object,
	checkboxDisabledStatus: PropTypes.array,
	affiliateID: PropTypes.number,
	onChecked: PropTypes.func,
	intl: PropTypes.func
};

Fields.propTypes = {
	fields: PropTypes.object,
	checkboxDisabledStatus: PropTypes.array,
	addField: PropTypes.func,
	intl: PropTypes.func,
	removeField: PropTypes.func,
	onChecked: PropTypes.func,
	errors: PropTypes.object,
	changeUrl: PropTypes.func,
	postbackTypeErrors: PropTypes.array,
	fieldsLimit: PropTypes.number
};

export default reduxForm({
	form: 'globalPostbackForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/global-postback/components/form.js